export const APPEND_STORAGE_IMAGE = 'APPEND_STORAGE_IMAGE';
export const REMOVE_STORAGE_IMAGE = 'REMOVE_STORAGE_IMAGE';
